import { findHTMLTags } from '../../../common/text-markup.js';

const matchChar = (char, regex) => !!char.match(regex);
const lineClamp = (string, length) => {
    const ellipsis = '';
    const ignoredChars = /\u9999\?\.,;!¡¿。、·: /;
    const htmlTags = findHTMLTags(string);
    const truncatedString = string.substring(0, length + (htmlTags ? htmlTags.join('').length : 0));
    const isEllipsis = !matchChar(truncatedString[truncatedString.length - 1], ignoredChars);
    const isPunctuation = string.length === length + 1 &&
        matchChar(string[string.length - 1], ignoredChars);
    const modifiedText = `${truncatedString}${isEllipsis ? ellipsis : ''}`;
    return string.length > length && !isPunctuation ? modifiedText : string;
};
const truncateSlotContent = (slot, strings) => {
    var _a;
    const text = slot;
    if (((_a = text === null || text === void 0 ? void 0 : text.dataset) === null || _a === void 0 ? void 0 : _a.text) && (text === null || text === void 0 ? void 0 : text.textContent)) {
        text.innerHTML = lineClamp(text.dataset.text, strings);
    }
};
const setLineClamp = (ctx, headingCharLimit, textCharLimit) => {
    if (ctx.headingSlot && headingCharLimit !== null)
        truncateSlotContent(ctx.headingSlot, headingCharLimit);
    if (!ctx.textSlot || textCharLimit === null)
        return;
    truncateSlotContent(ctx.textSlot, textCharLimit);
};

export { lineClamp, setLineClamp, truncateSlotContent };
